module.exports = __webpack_public_path__ + "img/firstSectionImage.899e9625.png";